/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
import { HTMLAttributes } from 'react'
import ReactDOM from 'react-dom'
import classNames from 'classnames'
import { Button, Heading, Icon } from '@alto-avios/alto-ui'
import styles from './Drawer.module.scss'

type DrawerProps = HTMLAttributes<HTMLDivElement> & {
  title: string
  openButtonText?: string
  isOpen?: boolean
  onOpen?: () => void
  onClose?: () => void
  placement?: 'top' | 'right' | 'bottom' | 'left'
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'full'
  portalId?: string
}

const Drawer = (props: DrawerProps) => {
  const {
    children,
    title,
    openButtonText,
    isOpen,
    onOpen,
    onClose,
    placement = 'right',
    size,
    portalId,
    ...other
  } = props

  const Content = (
    <div
      role="dialog"
      {...other}
      className={classNames(styles.drawer, styles[placement], isOpen ? styles.open : styles.closed)}
    >
      <div className={styles.overlay} onClick={onClose} />
      <div className={styles.content}>
        <div className={styles.header}>
          <Heading as="h5">{title}</Heading>
          <Button onPress={onClose} styleVariant="white" aria-label="Close">
            <Icon iconName="xmark" iconSize="2x" />
          </Button>
        </div>
        <div className={styles.body}>{children}</div>
      </div>
    </div>
  )

  if (portalId) {
    const portalRoot = document.getElementById(portalId)
    return portalRoot ? ReactDOM.createPortal(Content, portalRoot) : null
  }

  return Content
}

export default Drawer
